export default __webpack_public_path__ + "static/media/vae1.510ea3d0.png";